<template>
  <div>

    <v-layout v-show="!dataLoaded || inAction" justify-center align-center style="height: 100%;width: 100%;position: absolute;">
      <v-progress-circular
          :size="64"
          indeterminate
          color="primary">
      </v-progress-circular>
    </v-layout>

    <v-form v-show="dataLoaded && !inAction" ref="inputForm" @submit.prevent="">
      <v-container px-10 fill-height ms-auto class="containerMaxWidth">    
        <v-stepper non-linear>
          <div class="c-stepper__header">
            <div tabindex="-1" class="c-stepper__step">
                <span class="c-stepper__step__step primary"><v-icon icon="icon" color="white">mdi-login-variant</v-icon></span>
              <div class="c-stepper__label">{{ $let('Payment_SectionTitle') }}</div>
            </div>
          </div>
        </v-stepper>
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="12">
            <v-sheet color="white" class="custom-shadow pa-10">  
              <v-row no-gutters>
                <v-col cols="12" sm="12" md="12">
                  <div ref="payment" v-html="paymentStatement"></div>
                  <div ref="cardLogoScript" id="cardLogoScript"></div>
                  <div ref="termsAndConditions" v-html="termsAndConditions"></div>
                  <div ref="refundPolicy" v-html="refundPolicy"></div>
                </v-col>
              </v-row>
          
              <StepperButtons
                @continueClick="_paymentContinueClick"
                @backClick="_backButtonClick">
              </StepperButtons>

            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-form ref="worldpayForm" :action="model.worldpayUrl" method=POST>
      <input type="hidden" name="testMode" :value="model.testMode">
      <input type="hidden" name="instId" :value="model.instId">
      <input type="hidden" name="cartId" :value="model.cartId">
      <input type="hidden" name="desc" :value="model.desc">
      <input type="hidden" name="amount" :value="model.amount">
      <input type="hidden" name="currency" :value="model.currency">
      <input type="hidden" name="hideCurrency" value="">
      <input type="hidden" name="signature" v-model="model.signature">
    </v-form>

  </div>
</template>

<script>

  import { mapState, mapActions } from "vuex";
  import StepperButtons from '../components/stepper-buttons.vue'  
  import generic from '@/shared/utils/generic.js';
  import opmGeneric from '../utils/generic.js';
  import paramKeys from '../constants/param-keys.js'
  import validators from '@/shared/utils/validators.js';
  import router from '../router';
  import routerNames from '../router/router-names';
  import postscribe from 'postscribe';
  import { v4 as uuidv4 } from 'uuid';
  import { service } from '../store/service.js'
  import constants from '../constants/generic.js';
  
  export default {
    name: 'Payment',
    components: {
      StepperButtons
    },
    props: {
      dataLoaded: { type: Boolean, default: false },
    },
    data() {
      return {
        validationRules: validators.validationRules({ reqFld: this.$let('RequiredFieldEmptyMessage') }),        
        paymentStatement: '',
        termsAndConditions: '',
        refundPolicy: '',
        inAction: false,
        model: {
          worldpayUrl: undefined,
          testMode: undefined,
          instId: undefined,
          cartId: undefined,
          desc: undefined,
          amount: undefined,
          currency: undefined,
          signature: undefined,
          cardScriptUrl: undefined
        },
        signature: undefined
      };
    },
    
    watch: {
      dataLoaded: {
        immediate: true,
        handler(value) {
          if (value) {
            if (this.$route.query.s === '1') {
              this.confirmPayment();
            }
            if (this.paymentConfirmed) {
              router.replace({ name: routerNames.ValidateMobile });
            }
          }
        }
      }
    },

    async mounted() {
      if (!this.$store.state.loanEnquiryData.eligible) router.push({ name: routerNames.Home })

      let currency = "";
      switch (opmGeneric.currentCurrency()) {
        case '£':
          currency = 'GBP';
          break;
        case '€':
          currency = 'EUR';
          break;
      }

      const paymentValue = generic.formatCurrencyToUi(this.model.paymentValue, opmGeneric.currencyConfig());
      const instId = generic.paramValue(this.$store, paramKeys.PaymentStepInstallationId);

      this.model = {
        worldpayUrl: generic.paramValue(this.$store, paramKeys.PaymentStepServiceUrl),
        testMode: generic.paramValue(this.$store, paramKeys.PaymentStepTestMode),
        instId: instId,
        cartId: uuidv4(),
        desc: generic.paramValue(this.$store, paramKeys.PaymentStepItemDescription),
        amount: parseFloat(generic.paramValue(this.$store, paramKeys.PaymentStepValue)),
        currency: currency,
        signature: "",
        cardScriptUrl: generic.paramValue(this.$store, paramKeys.PaymentStepCardsUrl)
                              .replaceAll("{installationId}", instId),
      };

      this.inAction = true;
          
      const resp = await service.generateSignature({
        "Value": JSON.stringify(this.model)
      });          

      if (resp && resp.Response.StatusCode === constants.LOAN_ENQUIRY_SUCCESS) {            
        this.model.signature = resp.HashedValue;
      }
      this.inAction = false;     

      this.paymentStatement = this.$let('Payment_Statement').replaceAll("{LoanEnquiryPaymentStepValue}", paymentValue);
      this.termsAndConditions = this.$let('Payment_TermsAndConditions');
      this.refundPolicy = this.$let('Payment_RefundPolicy');

      if (this.$refs.cardLogoScript) {
        /* eslint-disable no-useless-escape */
        postscribe('#cardLogoScript', `<script src="${this.model.cardScriptUrl}"><\/script>`);
      }
    },
    methods: {
      ...mapActions(["confirmPayment"]),

      _backButtonClick() { 
        router.push({ name: routerNames.ConfirmMembership });
      },

      async _paymentContinueClick() {                  
          this.$refs.worldpayForm.$el.submit();
      },
    },
    
    computed: mapState(['paymentConfirmed'])
  };
</script>

<style lang="scss" scoped>

</style>